import { TwoFactorMethodSetupAuthAppComponent } from '../components/two-factor-method-setup-auth-app/two-factor-method-setup-auth-app.component';
import { TwoFactorMethodSetupEmailComponent } from '../components/two-factor-method-setup-email/two-factor-method-setup-email.component';
import { TwoFactorMethodSetupPhoneComponent } from '../components/two-factor-method-setup-phone/two-factor-method-setup-phone.component';
import { TwoFAType } from '../domain/two-factor';
import { Injectable } from '@angular/core';
import { PplDialogService } from '@ppl/ui/dialog';
import type { DialogResponse } from '@ppl/utils/dialog.utils';
import type { Observable } from 'rxjs';
import type { TwoFactorMethodSetupAuthAppData, TwoFactorMethodSetupAuthAppResponse } from '../components/two-factor-method-setup-auth-app/two-factor-method-setup-auth-app.component';
import type { TwoFactorMethodSetupEmailData, TwoFactorMethodSetupEmailResponse } from '../components/two-factor-method-setup-email/two-factor-method-setup-email.component';
import type { TwoFactorMethodSetupPhoneData, TwoFactorMethodSetupPhoneResponse } from '../components/two-factor-method-setup-phone/two-factor-method-setup-phone.component';
import type { TwoFactorSetupMethodType } from '../domain/two-factor';


@Injectable({
  providedIn: 'root'
})
export class TwoFactorSetupService {

  constructor(
    private dialogService: PplDialogService
  ) { }

  setupMethod<T extends TwoFactorSetupMethodType>(data: {
    email: string,
    securityToken: string,
    type: T;
  }): Observable<TwoFactorSetupMethodResponseType<T>> {
    switch (data.type) {
      case TwoFAType.EMAIL:
        return this.dialogService.open<
          TwoFactorMethodSetupEmailComponent,
          TwoFactorMethodSetupEmailData,
          DialogResponse<TwoFactorMethodSetupEmailResponse>
        >(TwoFactorMethodSetupEmailComponent, {
          data: {
            email: data.email,
            securityToken: data.securityToken
          }
        }).afterClosed() as Observable<TwoFactorSetupMethodResponseType<T>>;
      case TwoFAType.AUTH_APP:
        return this.dialogService.open<
          TwoFactorMethodSetupAuthAppComponent,
          TwoFactorMethodSetupAuthAppData,
          DialogResponse<TwoFactorMethodSetupAuthAppResponse>
        >(TwoFactorMethodSetupAuthAppComponent, {
          data: {
            email: data.email,
            securityToken: data.securityToken
          }
        }).afterClosed() as Observable<TwoFactorSetupMethodResponseType<T>>;
      case TwoFAType.SMS:
        return this.dialogService.open<
          TwoFactorMethodSetupPhoneComponent,
          TwoFactorMethodSetupPhoneData,
          DialogResponse<TwoFactorMethodSetupPhoneResponse>
        >(TwoFactorMethodSetupPhoneComponent, {
          data: {
            securityToken: data.securityToken
          }
        }).afterClosed() as Observable<TwoFactorSetupMethodResponseType<T>>;
    }
  }
}

export type TwoFactorSetupMethodResponseType<T> =
  T extends TwoFAType.EMAIL ? DialogResponse<TwoFactorMethodSetupEmailResponse> :
  T extends TwoFAType.AUTH_APP ? DialogResponse<TwoFactorMethodSetupAuthAppResponse> :
  T extends TwoFAType.SMS ? DialogResponse<TwoFactorMethodSetupPhoneResponse> :
  never;
